import React from 'react';
import PropTypes from 'prop-types';

import './AuthBox.css';
import collectMeLogo from '../../images/collectme-logo.svg';

const AuthBox = ({ children }) => (
  <div className="authBox">
    <div className="authBox-logo">
      <img src={collectMeLogo} alt="CollectMe" />
    </div>
    <div className="authBox-content">{children}</div>
  </div>
);

AuthBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthBox;



// WEBPACK FOOTER //
// ./src/components/containers/AuthBox.jsx